export class PopupConfig<T> {
    fullscreen?: boolean;
    data?: T;
}
